import {h, Fragment} from "preact"
import { useSpeechToText, speechToTextSupported } from "@nosto/preact"

export default function SpeechToTextComponent({ onSubmit }) {
    const { startListening, listening } = useSpeechToText({
        onResult: onSubmit,
        onError: error => {
            console.error("Speech to text error:", error)
        }
    })

    const handleStart = (e) => {
        e.preventDefault()
        startListening()
    }

    if (!speechToTextSupported) {
        return <></>
    }

    return (
        <button className="ns-voice-to-text-button" onClick={handleStart} disabled={listening}>
            🎤︎︎
        </button>
    )
}
